import React, { Component } from 'react';
import { connect } from 'react-redux';
import LayoutView from './layout-view';
import { getAvailableDrivers } from '../available-drivers/available-drivers-actions';

class Layout extends Component {

  componentDidMount() {
    setInterval(() => {
      this.props.refreshDrivers(); // todo: is this best?
    }, 120000)
  }

  render() {
    return (
      <LayoutView {...this.props} />
    )
  }
}

const mapStateToProps = (state) => ({
  layout: state.layout
});

const mapDispatchToProps = {
  refreshDrivers: getAvailableDrivers
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);




// WEBPACK FOOTER //
// ./src/components/layout/layout.js